import React, { useEffect, useState } from 'react';
/* global axios */
import api from '../services/apiService';
import { useNavigate, useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet';  // Import von React Helmet
import Select from 'react-select'; // react-select importieren
import AsyncSelect from 'react-select/async';

const OfferList = () => {
  const [offers, setOffers] = useState([]);
  const navigate = useNavigate();
  const [isConvertingToOrder, setIsConvertingToOrder] = useState(false);
  const [isDuplicatingOffer, setIsDuplicatingOffer] = useState(false);

  // Initialer Filter-State (wird aus Local Storage geladen oder mit leeren Werten initialisiert)
 const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const urlOfferNumber = urlParams.get('offerNumber');

const focusOfferNumber = location.state?.focusOfferNumber || null;

 const [filters, setFilters] = useState(() => {
  const saved = localStorage.getItem("offerFilters");
  const init = saved
    ? JSON.parse(saved)
    : {
        offerNumber: null,
        customer: null,
        contact: null,
        date: null,
        validUntil: null,
        status: null,
        besteller: null,
      };

  // Priorität: focusOfferNumber (aus navigate state) > offerNumber in URL
  if (focusOfferNumber) {
    init.offerNumber = { value: focusOfferNumber, label: focusOfferNumber };
  } else if (urlOfferNumber) {
    init.offerNumber = { value: urlOfferNumber, label: urlOfferNumber };
  }

  return init;
});

useEffect(() => {
  if (focusOfferNumber) {
    // State aus der History entfernen, aber Filter bleibt gesetzt
    navigate(location.pathname, { replace: true, state: {} });
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []); 

  useEffect(() => {
    localStorage.setItem("offerFilters", JSON.stringify(filters));
    setCurrentPage(1); // Bei Filteränderungen Seite zurücksetzen
  }, [filters]);

  // Serverseitige Filteroptionen laden
  const [serverFilterOptions, setServerFilterOptions] = useState({
    offerNumbers: [],
    customers: [],
    besteller: [],
    contacts: [],
    dates: [],
    validUntil: [], // statt "validUntils"
    statuses: [],
  });

  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        const response = await api.get('/offers/filter-options');
        setServerFilterOptions(response.data);
      } catch (error) {
        console.error('Fehler beim Laden der Filteroptionen:', error);
      }
    };
    fetchFilterOptions();
  }, []);

  // === Kundenwahl-Modal für neues Angebot ===
const [showCreateOfferModal, setShowCreateOfferModal] = useState(false);
const [createOfferCustomer, setCreateOfferCustomer] = useState(null);
const [isCreatingOffer, setIsCreatingOffer] = useState(false);

// Kunden-Suche für AsyncSelect (/customers/search?q=…)
const loadCustomerOptions = async (inputValue) => {
  const q = (inputValue || '').trim();
  if (q.length < 2) return [];
  try {
    const { data } = await api.get(`/customers/search?q=${encodeURIComponent(q)}&limit=20`);
    return (data || []).map(c => ({
      value: c.id,
      label: [
        c.company || [c.firstName, c.lastName].filter(Boolean).join(' '),
        c.customerNumber ? `(${c.customerNumber})` : null,
        c.city ? `– ${c.city}` : null
      ].filter(Boolean).join(' ')
    }));
  } catch (e) {
    console.error('customer search failed', e);
    return [];
  }
};

// Neues Angebot mit gewähltem Kunden anlegen
const createDraftOfferForCustomer = async (customerId) => {
  try {
    const payload = { customerId };
    const { data } = await api.post('/offers/draft', payload);
    const { editUrl } = data;
    navigate(editUrl);
  } catch (error) {
    console.error('Fehler beim Erstellen eines Angebotsentwurfs:', error);
    alert('Fehler beim Erstellen des Angebotsentwurfs!');
  }
};


  // Funktion zur Formatierung von Datumsangaben
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
  };

  // Pagination: aktueller Zustand
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 25;

  // Query-String basierend auf Filter- und Pagination-Parametern
  const buildQuery = () => {
    const params = new URLSearchParams();
    params.append('limit', limit);
    params.append('page', currentPage);
    if (filters.offerNumber) {
      params.append('offerNumber', filters.offerNumber.value);
    }
    if (filters.status) {
      params.append('status', filters.status.value);
    }
    if (filters.date) {
      params.append('date', filters.date.value);
    }
    if (filters.validUntil) {
      params.append('validUntil', filters.validUntil.value);
    }
    if (filters.customer) {
      params.append('customer', filters.customer.value);
    }
    if (filters.besteller) {
      params.append('besteller', filters.besteller.value);
    }
    return params.toString() ? `?${params.toString()}` : '';
  };

  useEffect(() => {
    const fetchOffers = async () => {
      try {
        const query = buildQuery();
        const response = await api.get(`/offers/list${query}`);
        // Erwarteter Response: { total, page, pages, data: [...] }
        setOffers(response.data.data);
        setTotalPages(response.data.pages);
      } catch (error) {
        console.error("Fehler beim Abrufen der Angebote:", error);
      }
    };
    fetchOffers();
  }, [filters, currentPage]);

  const handleViewPDF = (offerId) => {
    const pdfUrl = `${api.defaults.baseURL}/documents/offer/${offerId}/pdf`;
    window.open(pdfUrl, '_blank');
  };

  const deleteOffer = (id) => {
    if (window.confirm('Möchten Sie dieses Angebot wirklich löschen?')) {
      api.delete(`/offers/${id}`)
        .then(() => {
          setOffers((prev) => prev.filter((offer) => offer.id !== id));
          alert('Angebot erfolgreich gelöscht!');
        })
        .catch((error) => console.error('Fehler beim Löschen des Angebots:', error));
    }
  };

  const handleConvertToOrder = async (offerId) => {
    if (!window.confirm('Möchten Sie dieses Angebot in einen Auftrag duplizieren?')) {
      return;
    }
    setIsConvertingToOrder(true);
    try {
      const response = await api.post(`/orders/duplicate/${offerId}`);
      alert('Angebot erfolgreich in einen Auftrag dupliziert.');
      navigate(response.data.editUrl);
    } catch (error) {
      console.error('Fehler beim Duplizieren des Angebots:', error);
      if (error.response && error.response.data && error.response.data.error) {
        alert(`Fehler beim Duplizieren des Angebots: ${error.response.data.error}`);
      } else {
        alert('Fehler beim Duplizieren des Angebots.');
      }
    } finally {
      setIsConvertingToOrder(false);
    }
  };

  const handleDuplicateOffer = async (offerId) => {
    if (!window.confirm('Dieses Angebot duplizieren und als Entwurf speichern?')) {
      return;
    }

    setIsDuplicatingOffer(true);
    try {
      const response = await api.post(`/offers/${offerId}/duplicate`);
      if (response.data?.offerId) {
        alert('Angebot wurde erfolgreich dupliziert.');
        navigate(response.data.editUrl);
      } else {
        alert('Fehler: Angebot konnte nicht dupliziert werden.');
      }
    } catch (error) {
      console.error('Fehler beim Duplizieren des Angebots:', error);
      if (error.response?.data?.error) {
        alert(`Fehler beim Duplizieren des Angebots: ${error.response.data.error}`);
      } else {
        alert('Fehler beim Duplizieren des Angebots.');
      }
    } finally {
      setIsDuplicatingOffer(false);
    }
  };



  const sendOfferMail = async (offerId) => {
    try {
      await api.post(`/documents/offer/${offerId}/mail`);
      alert('✅ Angebot erfolgreich gemailt!');
    } catch (error) {
      console.error('Fehler beim Mailen des Angebots:', error);
      alert('Fehler beim Mailen des Angebots!');
    }
  };

  return (
    <div className="offer-list">
      <Helmet>
        <title>Angebotliste</title>
        <meta name="description" content="Angebotliste" />
      </Helmet>
      <h1>Angebote</h1>

      <button
  onClick={() => {
    setShowCreateOfferModal(true);
    setCreateOfferCustomer(null);
  }}
  style={{ marginBottom: '20px' }}
>
  Neues Angebot erstellen
</button>

      {/* Filterleiste */}
      <div style={{ marginBottom: '20px' }}>
        <h3>Filter</h3>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '10px' }}>
          <Select
            options={serverFilterOptions.offerNumbers.map(val => ({ value: val, label: val }))}
            placeholder="Angebotsnummer"
            isClearable
            value={filters.offerNumber}
            onChange={(selected) => setFilters({ ...filters, offerNumber: selected })}
          />
          <Select
            options={serverFilterOptions.customers.map(val => ({ value: val, label: val }))}
            placeholder="Kunde"
            isClearable
            value={filters.customer}
            onChange={(selected) => setFilters({ ...filters, customer: selected })}
          />
          <Select
  options={serverFilterOptions.besteller.map(val => ({ value: val, label: val }))}
  placeholder="Besteller"
  isClearable
  value={filters.besteller}
  onChange={(selected) => setFilters({ ...filters, besteller: selected })}
/>
          <Select
            options={serverFilterOptions.dates.map(val => ({ value: val, label: val }))}
            placeholder="Angebotsdatum"
            isClearable
            value={filters.date}
            onChange={(selected) => setFilters({ ...filters, date: selected })}
          />
          <Select
  options={serverFilterOptions.validUntil.map(val => ({ value: val, label: val }))}
  placeholder="Gültig bis"
  isClearable
  value={filters.validUntil}
  onChange={(selected) => setFilters({ ...filters, validUntil: selected })}
  menuPortalTarget={document.body}        // Menü in ein Portal rendern
  menuPosition="fixed"                    // vermeidet Clipping/Scroll-Probleme
  styles={{
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    menu: base => ({ ...base, zIndex: 9999 }),
  }}
/>
          <Select
            options={serverFilterOptions.statuses.map(val => ({ value: val, label: val }))}
            placeholder="Status"
            isClearable
            value={filters.status}
            onChange={(selected) => setFilters({ ...filters, status: selected })}
            menuPortalTarget={document.body}        // Menü in ein Portal rendern
  menuPosition="fixed"                    // vermeidet Clipping/Scroll-Probleme
  styles={{
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    menu: base => ({ ...base, zIndex: 9999 }),
  }}
          />
        </div>
      </div>

      {/* Tabelle */}
      {offers.length > 0 ? (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Angebotsnummer</th>
              <th>Kunde</th>
              <th>Besteller</th>
              <th>Angebotsdatum</th>
              <th>Gültig bis</th>
              <th>Einsatzort</th>
              <th>Status</th>
              <th>Gesamt netto (€)</th>
              <th>Aktionen</th>
              <th>Ausgabe</th>
            </tr>
          </thead>

          <tbody>
  {offers.map((offer) => {
    // --- Prüfung, ob Ausgabe erlaubt ist (gültiger updator) ---
    const updatedByValid = !!offer.updatedBy;

    return (
      <tr key={offer.id}>
        <td>{offer.id}</td>
        <td>{offer.offerNumber}</td>
        <td>{offer.customer?.company || `${offer.customer?.firstName} ${offer.customer?.lastName}` || 'Unbekannt'}</td>
        <td>{offer.contact ? `${offer.contact.contactFirstName} ${offer.contact.contactLastName}` : 'Kein Besteller ausgewählt'}</td>
        <td>{formatDate(offer.date)}</td>
        <td>{formatDate(offer.validUntil)}</td>
        <td>{offer.operationLocation || 'Nicht angegeben'}</td>
        <td>{offer.status}</td>
        <td>{offer.totalNet?.toFixed(2).replace('.', ',')}</td>
        <td style={{ border: '1px solid #ddd', padding: '8px' }}>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <button
              type="button"
              onClick={() => navigate(`/offers/${offer.id}/edit`)}
              style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#007bff',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                marginRight: '10px',
                cursor: 'pointer',
              }}
            >
              Bearbeiten
            </button>
            <button
              type="button"
              onClick={() => deleteOffer(offer.id)}
              style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: '#dc3545',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer',
              }}
            >
              Löschen
            </button>
            {offer.status !== 'ordered' && updatedByValid && (
              <button
                type="button"
                onClick={() => handleConvertToOrder(offer.id)}
                disabled={isConvertingToOrder}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: isConvertingToOrder ? '#6c757d' : '#28a745',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  marginLeft: '10px',
                  cursor: isConvertingToOrder ? 'not-allowed' : 'pointer',
                }}
              >
                {isConvertingToOrder ? 'Erzeuge Auftrag...' : 'in Auftrag'}
              </button>
            )}
            {updatedByValid && (
              <button
                type="button"
                onClick={() => handleDuplicateOffer(offer.id)}
                disabled={isDuplicatingOffer}
                style={{
                  fontSize: '15px',
                  padding: '5px 10px',
                  background: isDuplicatingOffer ? '#6c757d' : '#FFA500',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  marginLeft: '10px',
                  cursor: isDuplicatingOffer ? 'not-allowed' : 'pointer',
                }}
                title="Angebot duplizieren"
              >
                {isDuplicatingOffer ? 'Dupliziere...' : '🔁'}
              </button>
            )}
          </div>
        </td>
        <td>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
            <button
              onClick={() => handleViewPDF(offer.id)}
              disabled={!updatedByValid}
              style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: !updatedByValid ? '#cfd8dc' : '#28a745',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: !updatedByValid ? 'not-allowed' : 'pointer',
              }}
              title={
                !updatedByValid
                  ? "Das Angebot muss erst vollständig gespeichert werden!"
                  : undefined
              }
            >
              Ansicht
            </button>
            <button
              onClick={() => sendOfferMail(offer.id)}
              disabled={!updatedByValid}
              style={{
                fontSize: '15px',
                padding: '5px 10px',
                background: !updatedByValid ? '#cfd8dc' : '#17a2b8',
                color: '#fff',
                border: 'none',
                borderRadius: '5px',
                cursor: !updatedByValid ? 'not-allowed' : 'pointer',
              }}
              title={
                !updatedByValid
                  ? "Das Angebot muss erst vollständig gespeichert werden!"
                  : undefined
              }
            >
              Mailen
            </button>
          </div>
        </td>
      </tr>
    );
  })}
</tbody>

        </table>
      ) : (
        <p>Keine Angebote verfügbar.</p>
      )}

      {/* Pagination */}
      <div style={{ marginTop: '1rem' }}>
        <button
          onClick={() => setCurrentPage(currentPage > 1 ? currentPage - 1 : 1)}
          disabled={currentPage === 1}
          style={{
            fontSize: '15px',
            padding: '8px 12px',
            backgroundColor:'rgb(155, 155, 155)',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }} 
        >
          Vorherige
        </button>
        <span style={{ margin: '0 1rem' }}>
          Seite {currentPage} von {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage(currentPage + 1)}
          disabled={currentPage >= totalPages}
          style={{
            fontSize: '15px',
            padding: '8px 12px',
            backgroundColor:'rgb(155, 155, 155)',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer'
          }} 
        >
          Nächste
        </button>
      </div>


{showCreateOfferModal && (
  <div style={{
    position:'fixed', inset:0, background:'rgba(0,0,0,0.4)',
    display:'flex', alignItems:'center', justifyContent:'center', zIndex: 9999
  }}>
    <div style={{ background:'#fff', padding:'20px', borderRadius:'8px', width:'min(520px, 95vw)' }}>
      <h3>Neues Angebot – Kunde wählen</h3>
      <p style={{ margin: '8px 0 12px 0' }}>
        Bitte wähle zuerst den Kunden aus.
      </p>

      <label style={{ display:'grid', gap:6 }}>
        <span>Kunde</span>
        <AsyncSelect
          cacheOptions
          defaultOptions={false}           // erst bei Eingabe suchen
          loadOptions={loadCustomerOptions}
          onChange={(opt) => setCreateOfferCustomer(opt)}
          value={createOfferCustomer}
          placeholder="Kundenname, Nummer, Stadt, E-Mail…"
          isClearable
          // Dropdown über alles rendern (Z-Index Fix)
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            container: (b) => ({ ...b, minWidth: 360 }),
            menuPortal: (b) => ({ ...b, zIndex: 99999 }),
            menu: (b) => ({ ...b, zIndex: 99999 }),
          }}
        />
      </label>

      <div style={{ display:'flex', gap:10, justifyContent:'flex-end', marginTop:16 }}>
        <button
          onClick={() => {
            if (isCreatingOffer) return;
            setShowCreateOfferModal(false);
            setCreateOfferCustomer(null);
          }}
          style={{ background:'#eee', color:'#333', padding:'8px 12px', border:'none', borderRadius:6 }}
          disabled={isCreatingOffer}
        >
          Abbrechen
        </button>
        <button
          onClick={async () => {
            if (!createOfferCustomer) { alert('Bitte zuerst einen Kunden wählen.'); return; }
            try {
              setIsCreatingOffer(true);
              await createDraftOfferForCustomer(createOfferCustomer.value);
              setShowCreateOfferModal(false);
            } finally {
              setIsCreatingOffer(false);
            }
          }}
          disabled={isCreatingOffer || !createOfferCustomer}
          style={{
            background:'#2eae4a', color:'#fff', padding:'8px 12px',
            border:'none', borderRadius:6,
            opacity: (isCreatingOffer || !createOfferCustomer) ? .7 : 1,
            cursor: (isCreatingOffer || !createOfferCustomer) ? 'not-allowed' : 'pointer'
          }}
        >
          {isCreatingOffer ? 'Lege an…' : 'Angebot anlegen'}
        </button>
      </div>
    </div>
  </div>
)}

      
    </div>
  );
};

export default OfferList;
